(function(){
'use strict';

angular.module('classy').component('donationGridCustomAmount', {
  templateUrl: 'global/components/fields/donationGridCustomAmount/donation-custom-amount', // same folder as this
  bindings: {
    model: '=',
    disableFlag: '=?',
    name: '<',
    currencyCode: '<?',
    placeholder: '<',
    errorMessages: '<?',
    getterSetter: '<?',
    roundCurrency: '<?',
    currencyAriaLabel: '@?',
    modalBindValue: '=?',
    selected: '<?',
    inputDataId: '@?'
  },
  require: {
    form: '^form'
  },
  controller: ["$element", "$scope", "EmbeddedGivingColors", "scCurrencyService", "scQaId", "scThemesService", function CurrencyFieldCtrl($element, $scope, EmbeddedGivingColors, scCurrencyService, scQaId, scThemesService) {
    var _this = this;

    this.scQaId = scQaId;
    this.getterSetter = false;
    this.required = false;
    this.disabled = false;
    this.roundCurrency = true;
    this.min = 1;
    this.max = 10000000;
    this.errorMessages = {
      min: 'Please enter an amount greater than or equal to 1.',
      max: 'Please enter an amount smaller than or equal to 10,000,000.',
      required: 'Please enter an amount.',
      parse: 'Please enter a valid currency amount.'
    };
    this.colorPrimary = EmbeddedGivingColors.getPrimary(scThemesService.active);
    this.colorAccent = EmbeddedGivingColors.getAccent(scThemesService.active);
    this.colorAccentOpaque = EmbeddedGivingColors.getAccentOpaque(scThemesService.active);

    this.$onInit = function () {
      if (_this.modalBindValue > 0) {
        setTimeout(function () {
          _this.form.amount.$setValidity('min', true);
          _this.form.amount.$setValidity('max', true);
        }, 50);
      }
      // _.defaultsDeep(this, DEFAULTS.call(this));
      _this.setupSelectListener();

      if (_this.currencyCode) {
        _this.symbol = scCurrencyService.getCurrencySymbol(_this.currencyCode);
      }
    };

    this.$onChanges = function () {
      _this.symbol = scCurrencyService.getCurrencySymbol(_this.currencyCode);
    };

    this.onChange = function () {
      _this.modalBindValue = _this.model;
      _this.symbol = scCurrencyService.getCurrencySymbol(_this.currencyCode);

      if (_this.model > 0) {
        _this.form.amount.$setValidity('required', true);
        _this.form.amount.$setValidity('max', true);
        _this.form.amount.$setValidity('min', true);
      } else if (_this.model === undefined) {
        _this.form.amount.$setValidity('required', false);
      }
    };

    this.onBlur = function () {
      if (!_this.form.amount.$$rawModelValue) {
        _this.form.amount.$setPristine();

        _this.form.amount.$error.required = false;
        _this.form.amount.$error.max = false;
        _this.form.amount.$error.min = false;
      }
    };

    this.setupSelectListener = function () {
      if (_this.selectOn) {
        $scope.$on(_this.selectOn, function () {
          $element.find('input').focus();
          $element.find('input').select();
        });
      }
    };

    this.getStylesDefault = function () {
      return {
        'background-color': _this.colorAccentOpaque,
        'border-color': _this.colorAccentOpaque
      };
    };

    this.getStylesSelected = function () {
      return {
        'border-color': _this.colorPrimary,
        'background-color': _this.colorPrimary
      };
    };

    $scope.$on('selectedAmountChange', function (_evt, convertedAmount) {
      _this.model = convertedAmount > 0 ? convertedAmount : '';
    });
  }]
});
})();